import {ITableReportDrillDown} from 'store/slices/table-report-slice/table-report-slice-types';

import {TPushWithBreadcrumbsFunction} from '../hooks/use-breadcrumbs-controller';

interface IPerformDrilldownPushArgs {
    pushWithBreadcrumbs: TPushWithBreadcrumbsFunction;
    ddEntry: ITableReportDrillDown;
}

export const performDrilldownPush = ({
    ddEntry,
    pushWithBreadcrumbs,
}: IPerformDrilldownPushArgs) => {
    const ddPath = [
        '/table-reports',
        ...(ddEntry?.docId ? [`/${ddEntry?.docId}`] : []),
        `/${ddEntry?.templateCode}`,
    ].join('');

    pushWithBreadcrumbs({
        name: ddEntry.templateName ?? ddEntry?.docTypeName ?? 'Неизвестно',
        path: ddPath,
        extraData: {
            tableReportDrilldownParams: {
                drillId: ddEntry.drillId,
                drillParameters: ddEntry.parameters,
            },
            tableReportLocationDefaults: {
                locationPage: undefined,
                locationSize: undefined,
            },
        },
    });
};
